import bioSecurity1 from '../assets/bioSec1.svg';
import bioSecurity2 from '../assets/bioSec2.svg';
import bioSecurity3 from '../assets/bioSec3.svg';

class Location implements ILocation {
  _id: ILocation['_id'];
  name: ILocation['name'];
  bioSecurity: ILocation['bioSecurity'];

  constructor(location: ILocation | null) {
    if (location) {
      this._id = location._id;
      this.name = location.name;
      this.bioSecurity = location.bioSecurity;
    } else {
      this._id = '';
      this.name = 'unknown';
      this.bioSecurity = 3;
    }
  }

  getIcon() {
    switch (this.bioSecurity) {
      case 1:
        return bioSecurity1;
      case 2:
        return bioSecurity2;
      case 3:
        return bioSecurity3;
      default:
        throw new TypeError(
          `${this.bioSecurity} not recognized as a bio security level`
        );
    }
  }

  getHelpText() {
    switch (this.bioSecurity) {
      case 1:
        return 'Bio security level 1 - the most lenient level';
      case 2:
        return 'Bio security level 2 - the middle level';
      case 3:
        return 'Bio security level 1 - the most restrictive level';
      default:
        throw new TypeError(
          `${this.bioSecurity} not recognized as a bio security level`
        );
    }
  }
}

export default Location;
